import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import CSVReader from 'react-csv-reader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { CustomerSchemaObject } from '../CustomerSchema';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'CUSTOMER';

export function CustomerCardAddEdit(props) {


    const { data, edit } = props.location;
   
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [isChanged, setIsChanged] = useState(0);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionCategory, setCollectionCategory] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [title, setTitle] = useState("Add Customer");
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [customer, setCustomer] = useState({
       
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        customerCode: '',
        title: '',
        firstName: '',
        secondName: '',
        lastName: '',
        gender: '',
        dateOfBirth:'',
        nic: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        countryCode: '',
        homePhoneNo: '',
        officePhoneNo: '',
        mobileNo: '',
        email: '',
        question: '',
        answer: '',
        collectionCatagoryID: '0',
        isSupplementary: false,
        registrationNumber: '',
        nameToBePrinted: ''

    });

    const [state, setState] = useState({
        isSupplementary: false,

    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(CustomerSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [customer.groupID]);

     useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
            
        )
    }, [customer.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointIDForDropdown()
        )
    }, [customer.collectionCatagoryID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITCUSTOMER');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setCustomer({
            ...customer,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

       

        if (data && edit) {
            setTitle("Edit Customer");
            setButtonName("Update");
            setIsEditScreen(true);
            getCustomerData(data);
        } else {
            setTitle("Add Customer");
        }
       
        trackPromise(
            getGroupsForDropdown(),

        )
    }
    async function getCustomerData(data){
        var customerID=data.customerID;
        var custInfo = await services.GetCustomerDetailsByCustomerID(customerID);
        var customerDetails = {
            customerID: (data && edit) ? parseInt(custInfo[0].customerID) : 0,
             groupID:(isNaN(custInfo[0].groupID)?0: parseInt(custInfo[0].groupID)),
             operationEntityID:(isNaN(custInfo[0].operationEntityID)?0: parseInt(custInfo[0].operationEntityID)),
             collectionCatagoryID:(isNaN(custInfo[0].collectionCatagoryID)||custInfo[0].collectionCatagoryID==null?0: parseInt(custInfo[0].collectionCatagoryID)),
             collectionPointID: parseInt(custInfo[0].collectionPointID),
             customerCode: custInfo[0].customerCode,
             title: custInfo[0].title,
             firstName: custInfo[0].firstName,
             secondName: custInfo[0].secondName,
             lastName: custInfo[0].lastName,
             gender: custInfo[0].gender,
             dateOfBirth: (custInfo[0].dateOfBirth==null?null:custInfo[0].dateOfBirth.split('T')[0]),
             nic: custInfo[0].nic,
             address1: custInfo[0].address1,
             address2: custInfo[0].address2,
             address3: custInfo[0].address3,
             city: custInfo[0].city,
             countryCode: custInfo[0].countryCode,
             homePhoneNo: custInfo[0].homePhoneNo,
             officePhoneNo: custInfo[0].officePhoneNo,
             mobileNo: custInfo[0].mobileNo,
             email: custInfo[0].email,
             question: custInfo[0].question,
             answer: custInfo[0].answer,
             collectionCatagoryID: parseInt(custInfo[0].collectionCatagoryID),
             isSupplementary: custInfo[0].isSupplementary,
             registrationNumber: custInfo[0].registrationNumber,
             nameToBePrinted: custInfo[0].nameToBePrinted
 
         }
         setCustomer(customerDetails);

    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.getFactoriesByGroupID(customer.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(customer.operationEntityID);
        setCollectionCategory(collectionCategories);
        
    }

    async function getCollectionPointIDForDropdown() {
        const collectionPoints = await services.GetCollectionPointsByCollectionCategoryID(customer.collectionCatagoryID);
        setCollectionPoints(collectionPoints);
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
        
    }


    function handleChange(e) {

        const target = e.target
        const value = target.name === 'isSupplementary' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, CustomerSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCustomer({
            ...customer,
            [e.target.name]: value
        });
        setState({
            ...state,
            [e.target.name]: value
        });

        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, customer);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        var customerDetails = {
            customerID: (data && edit) ? parseInt(data.customerID) : 0,
            groupID: parseInt(customer.groupID),
            operationEntityID: parseInt(customer.operationEntityID),
            collectionCatagoryID: parseInt(customer.collectionCatagoryID),
            collectionPointID: parseInt(customer.collectionPointID),
            customerCode: customer.customerCode,
            title: customer.title,
            firstName: customer.firstName,
            secondName: customer.secondName,
            lastName: customer.lastName,
            gender: customer.gender,
            dateOfBirth: customer.dateOfBirth,
            nic: customer.nic,
            address1: customer.address1,
            address2: customer.address2,
            address3: customer.address3,
            city: customer.city,
            countryCode: customer.countryCode,
            homePhoneNo: customer.homePhoneNo,
            officePhoneNo: customer.officePhoneNo,
            mobileNo: customer.mobileNo,
            email: customer.email,
            question: customer.question,
            answer: customer.answer,
            collectionCatagoryID: parseInt(customer.collectionCatagoryID),
            isSupplementary: state.isSupplementary,
            registrationNumber: customer.registrationNumber,
            nameToBePrinted: customer.nameToBePrinted

        }
        let response;
        if (!edit) {
            response = await services.saveCustomer(customerDetails);;
        } else {
            response = await services.updateCustomer(customerDetails);
        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }
    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/Customer' })
            }, 1500);
        }

    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })

    }

    function clearState() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setCustomer({
            ...customer,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityTypeID: "0",
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCatagoryID: "0",
            collectionPointID: "0",
            customerCode: '',
            title: '',
            firstName: '',
            secondName: '',
            lastName: '',
            gender: '',
            dateOfBirth: new Date().toISOString().split('T')[0],
            nic: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            countryCode: '',
            homePhoneNo: '',
            officePhoneNo: '',
            mobileNo: '',
            email: '',
            question: '',
            answer: '',
            isSupplementary: '',
            registrationNumber: '',
            nameToBePrinted: ''


        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path="/Customer"
                            />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Group *"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled||isEditScreen}
                                            value={customer.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <FormHelperText id="groupID" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Factory *"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled||isEditScreen}
                                            value={customer.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Factory--</option>
                                            {generateDropDownMenu(operationEntity)}
                                        </TextField>
                                        {errors["operationEntityID"] && <FormHelperText id="operationEntityID" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Collection Category *"
                                            id="collectionCatagoryID"
                                            name="collectionCatagoryID"
                                            value={customer.collectionCatagoryID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Collection Catagory--</option>
                                            {generateDropDownMenu(collectionCategory)}
                                        </TextField>
                                        {errors["collectionCatagoryID"] && <FormHelperText id="collectionCatagoryID" className="text text-danger">{errors["collectionCatagoryID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="row row-top-gap">
                                <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Collection Point *"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={customer.collectionPointID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Collection Point--</option>
                                            {generateDropDownMenu(collectionPoints)}
                                        </TextField>
                                        {errors["collectionPointID"] && <FormHelperText id="collectionPointID" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Customer Code"
                                            name="customerCode"
                                            id="customerCode"
                                            value={customer.customerCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />

                                        {errors["customerCode"] && <FormHelperText id="customerCode" className="text text-danger">{errors["customerCode"]}</FormHelperText>}
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="card">
                            <PageHeader
                                title="Customer Details" />
                            <div className="card-body">


                                <div className="row row-top-gap">
                                    <div className="col-md-4">

                                        <TextField select fullWidth label="Title *"
                                            name="title"
                                            id="title"
                                            value={customer.title}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} >
                                            <option value="0">Mr.</option>
                                            <option value="1">Ms.</option>
                                            <option value="2">Rev.</option>
                                            <option value="3">Dr.</option>
                                            <option value="4">Prof.</option>
                                        {errors["title"] && <FormHelperText id="title" className="text text-danger">{errors["title"]}</FormHelperText>}
                                        </TextField>
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="First Name *"
                                            name="firstName"
                                            id="firstName"
                                            value={customer.firstName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["firstName"] && <FormHelperText id="firstName" className="text text-danger">{errors["firstName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Second Name *"
                                            name="secondName"
                                            id="secondName"
                                            value={customer.secondName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["secondName"] && <FormHelperText id="secondName" className="text text-danger">{errors["secondName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Last Name *"
                                            name="lastName"
                                            id="lastName"
                                            value={customer.lastName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["lastName"] && <FormHelperText id="lastName" className="text text-danger">{errors["lastName"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4">

                                        <TextField select fullWidth label="Gender *"
                                            name="gender"
                                            id="gender"
                                            value={customer.gender}
                                            type="text"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} >
                                            <option value="0">Male</option>
                                            <option value="1">Female</option>
                                            <option value="2">Other</option>
                                        {errors["gender"] && <FormHelperText id="gender" className="text text-danger">{errors["gender"]}</FormHelperText>}
                                       </TextField>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Date Of Birth *"
                                            name="dateOfBirth"
                                            id="dateOfBirth"
                                            value={customer.dateOfBirth}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                                }} />

                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="NIC *"
                                            name="nic"
                                            id="nic"
                                            value={customer.nic}
                                            type="text"
                                            maxLength="12"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["nic"] && <FormHelperText id="nic" className="text text-danger">{errors["nic"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card">
                            <PageHeader
                                title="Address" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Address1 "
                                            name="address1"
                                            id="address1"
                                            value={customer.address1}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address1"] && <FormHelperText id="address1" className="text text-danger">{errors["address1"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Address2 "
                                            name="address2"
                                            id="address2"
                                            value={customer.address2}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address2"] && <FormHelperText id="address2" className="text text-danger">{errors["address2"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Address 3"
                                            name="address3"
                                            id="address3"
                                            value={customer.address3}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address3"] && <FormHelperText id="address3" className="text text-danger">{errors["address3"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="City "
                                            name="city"
                                            id="city"
                                            value={customer.city}
                                            type="text"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["city"] && <FormHelperText id="city" className="text text-danger">{errors["city"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Country "
                                            id="countryCode"
                                            name="countryCode"
                                            value={customer.countryCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Country--</option>
                                            <option value="1">Afghanistan</option>
                                            <option value="2">Canada</option>
                                            <option value="3">France	</option>
                                            <option value="4">	Hungary</option>
                                            <option value="5">	Sri Lanka</option>
                                            <option value="6">	Ukraine</option>

                                        </TextField>

                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="card">
                            <PageHeader
                                title="Contact" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Home Phone No"
                                            name="homePhoneNo"
                                            id="homePhoneNo"
                                            value={customer.homePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["homePhoneNo"] && <FormHelperText id="homePhoneNo" className="text text-danger">{errors["homePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Office Phone No "
                                            name="officePhoneNo"
                                            id="officePhoneNo"
                                            value={customer.officePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["officePhoneNo"] && <FormHelperText id="officePhoneNo" className="text text-danger">{errors["officePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Mobile No"
                                            name="mobileNo"
                                            id="mobileNo"
                                            value={customer.mobileNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["mobileNo"] && <FormHelperText id="mobileNo" className="text text-danger">{errors["mobileNo"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Email"
                                            name="email"
                                            id="email"
                                            value={customer.email}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["email"] && <FormHelperText id="email" className="text text-danger">{errors["email"]}</FormHelperText>}
                                    </div>

                                </div>
                            </div>


                        </div>
                        <div className="card">
                            <PageHeader
                                title="Verification" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Question"
                                            name="question"
                                            id="question"
                                            value={customer.question}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />

                                        {errors["question"] && <FormHelperText id="question" className="text text-danger">{errors["question"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Answer"
                                            name="answer"
                                            id="answer"
                                            value={customer.answer}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />

                                        {errors["answer"] && <FormHelperText id="answer" className="text text-danger">{errors["answer"]}</FormHelperText>}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Card Details" />
                            <div className="card-body">

                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Registration Number"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={customer.registrationNumber}
                                            type="text"
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)} />

                                        {errors["registrationNumber"] && <FormHelperText id="registrationNumber" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Name to be printed"
                                            name="nameToBePrinted"
                                            id="nameToBePrinted"
                                            value={customer.nameToBePrinted}
                                            type="text"
                                            //disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["nameToBePrinted"] && <FormHelperText id="nameToBePrinted" className="text text-danger">{errors["nameToBePrinted"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <label>Supplementary Card</label>
                                    <div className="form-group row">
                                        <div className="col-md-4 pb-1">
                                            <input
                                                className="mr-2"
                                                id="isSupplementary"
                                                switch="none"
                                                type="checkbox"
                                                name="isSupplementary"
                                                onChange={(e) => handleChange(e)}
                                                checked={customer.isSupplementary}
                                            />
                                            <label htmlFor="isSupplementary" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="card-footer">

                        <input
                            disabled={validate(schema, customer)}
                            type="submit"
                            className="btn btn-primary"
                            onClick={handleSave}
                            value={buttonName}
                        />

                        <input type="reset" className="btn btn-warning pull-right"
                            onClick={clearState}
                            value="Clear"
                        />
                    </div>
                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </div>
            </div>
        </Fragment >
    );
}